import gql from 'graphql-tag';

const getAssetQuery = gql`
  query getAsset($assetId: String!) {
    getAsset(assetId: $assetId) {
      filename
      createdAt
      metaData
      createdByUser {
        firstName
        lastName
      }
    }
  }
`;

export default () => ({
  query: getAssetQuery,
  module: 'assets',
  buildVariables: ({ assetId }: { assetId: string }) => ({ assetId })
});
